webpackJsonp([1],{

/***/ 0:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return h; });
/* unused harmony export createElement */
/* unused harmony export cloneElement */
/* unused harmony export createRef */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Component; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return render; });
/* unused harmony export rerender */
/* unused harmony export options */
var VNode = function VNode() {};

var options = {};

var stack = [];

var EMPTY_CHILDREN = [];

function h(nodeName, attributes) {
	var children = EMPTY_CHILDREN,
	    lastSimple,
	    child,
	    simple,
	    i;
	for (i = arguments.length; i-- > 2;) {
		stack.push(arguments[i]);
	}
	if (attributes && attributes.children != null) {
		if (!stack.length) stack.push(attributes.children);
		delete attributes.children;
	}
	while (stack.length) {
		if ((child = stack.pop()) && child.pop !== undefined) {
			for (i = child.length; i--;) {
				stack.push(child[i]);
			}
		} else {
			if (typeof child === 'boolean') child = null;

			if (simple = typeof nodeName !== 'function') {
				if (child == null) child = '';else if (typeof child === 'number') child = String(child);else if (typeof child !== 'string') simple = false;
			}

			if (simple && lastSimple) {
				children[children.length - 1] += child;
			} else if (children === EMPTY_CHILDREN) {
				children = [child];
			} else {
				children.push(child);
			}

			lastSimple = simple;
		}
	}

	var p = new VNode();
	p.nodeName = nodeName;
	p.children = children;
	p.attributes = attributes == null ? undefined : attributes;
	p.key = attributes == null ? undefined : attributes.key;

	if (options.vnode !== undefined) options.vnode(p);

	return p;
}

function extend(obj, props) {
  for (var i in props) {
    obj[i] = props[i];
  }return obj;
}

function applyRef(ref, value) {
  if (ref) {
    if (typeof ref == 'function') ref(value);else ref.current = value;
  }
}

var defer = typeof Promise == 'function' ? Promise.resolve().then.bind(Promise.resolve()) : setTimeout;

function cloneElement(vnode, props) {
  return h(vnode.nodeName, extend(extend({}, vnode.attributes), props), arguments.length > 2 ? [].slice.call(arguments, 2) : vnode.children);
}

var IS_NON_DIMENSIONAL = /acit|ex(?:s|g|n|p|$)|rph|ows|mnc|ntw|ine[ch]|zoo|^ord/i;

var items = [];

function enqueueRender(component) {
	if (!component._dirty && (component._dirty = true) && items.push(component) == 1) {
		(options.debounceRendering || defer)(rerender);
	}
}

function rerender() {
	var p;
	while (p = items.pop()) {
		if (p._dirty) renderComponent(p);
	}
}

function isSameNodeType(node, vnode, hydrating) {
	if (typeof vnode === 'string' || typeof vnode === 'number') {
		return node.splitText !== undefined;
	}
	if (typeof vnode.nodeName === 'string') {
		return !node._componentConstructor && isNamedNode(node, vnode.nodeName);
	}
	return hydrating || node._componentConstructor === vnode.nodeName;
}

function isNamedNode(node, nodeName) {
	return node.normalizedNodeName === nodeName || node.nodeName.toLowerCase() === nodeName.toLowerCase();
}

function getNodeProps(vnode) {
	var props = extend({}, vnode.attributes);
	props.children = vnode.children;

	var defaultProps = vnode.nodeName.defaultProps;
	if (defaultProps !== undefined) {
		for (var i in defaultProps) {
			if (props[i] === undefined) {
				props[i] = defaultProps[i];
			}
		}
	}

	return props;
}

function createNode(nodeName, isSvg) {
	var node = isSvg ? document.createElementNS('http://www.w3.org/2000/svg', nodeName) : document.createElement(nodeName);
	node.normalizedNodeName = nodeName;
	return node;
}

function removeNode(node) {
	var parentNode = node.parentNode;
	if (parentNode) parentNode.removeChild(node);
}

function setAccessor(node, name, old, value, isSvg) {
	if (name === 'className') name = 'class';

	if (name === 'key') {} else if (name === 'ref') {
		applyRef(old, null);
		applyRef(value, node);
	} else if (name === 'class' && !isSvg) {
		node.className = value || '';
	} else if (name === 'style') {
		if (!value || typeof value === 'string' || typeof old === 'string') {
			node.style.cssText = value || '';
		}
		if (value && typeof value === 'object') {
			if (typeof old !== 'string') {
				for (var i in old) {
					if (!(i in value)) node.style[i] = '';
				}
			}
			for (var i in value) {
				node.style[i] = typeof value[i] === 'number' && IS_NON_DIMENSIONAL.test(i) === false ? value[i] + 'px' : value[i];
			}
		}
	} else if (name === 'dangerouslySetInnerHTML') {
		if (value) node.innerHTML = value.__html || '';
	} else if (name[0] == 'o' && name[1] == 'n') {
		var useCapture = name !== (name = name.replace(/Capture$/, ''));
		name = name.toLowerCase().substring(2);
		if (value) {
			if (!old) node.addEventListener(name, eventProxy, useCapture);
		} else {
			node.removeEventListener(name, eventProxy, useCapture);
		}
		(node._listeners || (node._listeners = {}))[name] = value;
	} else if (name !== 'list' && name !== 'type' && !isSvg && name in node) {
		try {
			node[name] = value == null ? '' : value;
		} catch (e) {}
		if ((value == null || value === false) && name != 'spellcheck') node.removeAttribute(name);
	} else {
		var ns = isSvg && name !== (name = name.replace(/^xlink:?/, ''));

		if (value == null || value === false) {
			if (ns) node.removeAttributeNS('http://www.w3.org/1999/xlink', name.toLowerCase());else node.removeAttribute(name);
		} else if (typeof value !== 'function') {
			if (ns) node.setAttributeNS('http://www.w3.org/1999/xlink', name.toLowerCase(), value);else node.setAttribute(name, value);
		}
	}
}

function eventProxy(e) {
	return this._listeners[e.type](options.event && options.event(e) || e);
}

var mounts = [];

var diffLevel = 0;

var isSvgMode = false;

var hydrating = false;

function flushMounts() {
	var c;
	while (c = mounts.shift()) {
		if (options.afterMount) options.afterMount(c);
		if (c.componentDidMount) c.componentDidMount();
	}
}

function diff(dom, vnode, context, mountAll, parent, componentRoot) {
	if (!diffLevel++) {
		isSvgMode = parent != null && parent.ownerSVGElement !== undefined;

		hydrating = dom != null && !('__preactattr_' in dom);
	}

	var ret = idiff(dom, vnode, context, mountAll, componentRoot);

	if (parent && ret.parentNode !== parent) parent.appendChild(ret);

	if (! --diffLevel) {
		hydrating = false;

		if (!componentRoot) flushMounts();
	}

	return ret;
}

function idiff(dom, vnode, context, mountAll, componentRoot) {
	var out = dom,
	    prevSvgMode = isSvgMode;

	if (vnode == null || typeof vnode === 'boolean') vnode = '';

	if (typeof vnode === 'string' || typeof vnode === 'number') {
		if (dom && dom.splitText !== undefined && dom.parentNode && (!dom._component || componentRoot)) {
			if (dom.nodeValue != vnode) {
				dom.nodeValue = vnode;
			}
		} else {
			out = document.createTextNode(vnode);
			if (dom) {
				if (dom.parentNode) dom.parentNode.replaceChild(out, dom);
				recollectNodeTree(dom, true);
			}
		}

		out['__preactattr_'] = true;

		return out;
	}

	var vnodeName = vnode.nodeName;
	if (typeof vnodeName === 'function') {
		return buildComponentFromVNode(dom, vnode, context, mountAll);
	}

	isSvgMode = vnodeName === 'svg' ? true : vnodeName === 'foreignObject' ? false : isSvgMode;

	vnodeName = String(vnodeName);
	if (!dom || !isNamedNode(dom, vnodeName)) {
		out = createNode(vnodeName, isSvgMode);

		if (dom) {
			while (dom.firstChild) {
				out.appendChild(dom.firstChild);
			}
			if (dom.parentNode) dom.parentNode.replaceChild(out, dom);

			recollectNodeTree(dom, true);
		}
	}

	var fc = out.firstChild,
	    props = out['__preactattr_'],
	    vchildren = vnode.children;

	if (props == null) {
		props = out['__preactattr_'] = {};
		for (var a = out.attributes, i = a.length; i--;) {
			props[a[i].name] = a[i].value;
		}
	}

	if (!hydrating && vchildren && vchildren.length === 1 && typeof vchildren[0] === 'string' && fc != null && fc.splitText !== undefined && fc.nextSibling == null) {
		if (fc.nodeValue != vchildren[0]) {
			fc.nodeValue = vchildren[0];
		}
	} else if (vchildren && vchildren.length || fc != null) {
			innerDiffNode(out, vchildren, context, mountAll, hydrating || props.dangerouslySetInnerHTML != null);
		}

	diffAttributes(out, vnode.attributes, props);

	isSvgMode = prevSvgMode;

	return out;
}

function innerDiffNode(dom, vchildren, context, mountAll, isHydrating) {
	var originalChildren = dom.childNodes,
	    children = [],
	    keyed = {},
	    keyedLen = 0,
	    min = 0,
	    len = originalChildren.length,
	    childrenLen = 0,
	    vlen = vchildren ? vchildren.length : 0,
	    j,
	    c,
	    f,
	    vchild,
	    child;

	if (len !== 0) {
		for (var i = 0; i < len; i++) {
			var _child = originalChildren[i],
			    props = _child['__preactattr_'],
			    key = vlen && props ? _child._component ? _child._component.__key : props.key : null;
			if (key != null) {
				keyedLen++;
				keyed[key] = _child;
			} else if (props || (_child.splitText !== undefined ? isHydrating ? _child.nodeValue.trim() : true : isHydrating)) {
				children[childrenLen++] = _child;
			}
		}
	}

	if (vlen !== 0) {
		for (var i = 0; i < vlen; i++) {
			vchild = vchildren[i];
			child = null;

			var key = vchild.key;
			if (key != null) {
				if (keyedLen && keyed[key] !== undefined) {
					child = keyed[key];
					keyed[key] = undefined;
					keyedLen--;
				}
			} else if (min < childrenLen) {
					for (j = min; j < childrenLen; j++) {
						if (children[j] !== undefined && isSameNodeType(c = children[j], vchild, isHydrating)) {
							child = c;
							children[j] = undefined;
							if (j === childrenLen - 1) childrenLen--;
							if (j === min) min++;
							break;
						}
					}
				}

			child = idiff(child, vchild, context, mountAll);

			f = originalChildren[i];
			if (child && child !== dom && child !== f) {
				if (f == null) {
					dom.appendChild(child);
				} else if (child === f.nextSibling) {
					removeNode(f);
				} else {
					dom.insertBefore(child, f);
				}
			}
		}
	}

	if (keyedLen) {
		for (var i in keyed) {
			if (keyed[i] !== undefined) recollectNodeTree(keyed[i], false);
		}
	}

	while (min <= childrenLen) {
		if ((child = children[childrenLen--]) !== undefined) recollectNodeTree(child, false);
	}
}

function recollectNodeTree(node, unmountOnly) {
	var component = node._component;
	if (component) {
		unmountComponent(component);
	} else {
		if (node['__preactattr_'] != null) applyRef(node['__preactattr_'].ref, null);

		if (unmountOnly === false || node['__preactattr_'] == null) {
			removeNode(node);
		}

		removeChildren(node);
	}
}

function removeChildren(node) {
	node = node.lastChild;
	while (node) {
		var next = node.previousSibling;
		recollectNodeTree(node, true);
		node = next;
	}
}

function diffAttributes(dom, attrs, old) {
	var name;

	for (name in old) {
		if (!(attrs && attrs[name] != null) && old[name] != null) {
			setAccessor(dom, name, old[name], old[name] = undefined, isSvgMode);
		}
	}

	for (name in attrs) {
		if (name !== 'children' && name !== 'innerHTML' && (!(name in old) || attrs[name] !== (name === 'value' || name === 'checked' ? dom[name] : old[name]))) {
			setAccessor(dom, name, old[name], old[name] = attrs[name], isSvgMode);
		}
	}
}

var recyclerComponents = [];

function createComponent(Ctor, props, context) {
	var inst,
	    i = recyclerComponents.length;

	if (Ctor.prototype && Ctor.prototype.render) {
		inst = new Ctor(props, context);
		Component.call(inst, props, context);
	} else {
		inst = new Component(props, context);
		inst.constructor = Ctor;
		inst.render = doRender;
	}

	while (i--) {
		if (recyclerComponents[i].constructor === Ctor) {
			inst.nextBase = recyclerComponents[i].nextBase;
			recyclerComponents.splice(i, 1);
			return inst;
		}
	}

	return inst;
}

function doRender(props, state, context) {
	return this.constructor(props, context);
}

function setComponentProps(component, props, renderMode, context, mountAll) {
	if (component._disable) return;
	component._disable = true;

	component.__ref = props.ref;
	component.__key = props.key;
	delete props.ref;
	delete props.key;

	if (typeof component.constructor.getDerivedStateFromProps === 'undefined') {
		if (!component.base || mountAll) {
			if (component.componentWillMount) component.componentWillMount();
		} else if (component.componentWillReceiveProps) {
			component.componentWillReceiveProps(props, context);
		}
	}

	if (context && context !== component.context) {
		if (!component.prevContext) component.prevContext = component.context;
		component.context = context;
	}

	if (!component.prevProps) component.prevProps = component.props;
	component.props = props;

	component._disable = false;

	if (renderMode !== 0) {
		if (renderMode === 1 || options.syncComponentUpdates !== false || !component.base) {
			renderComponent(component, 1, mountAll);
		} else {
			enqueueRender(component);
		}
	}

	applyRef(component.__ref, component);
}

function renderComponent(component, renderMode, mountAll, isChild) {
	if (component._disable) return;

	var props = component.props,
	    state = component.state,
	    context = component.context,
	    previousProps = component.prevProps || props,
	    previousState = component.prevState || state,
	    previousContext = component.prevContext || context,
	    isUpdate = component.base,
	    nextBase = component.nextBase,
	    initialBase = isUpdate || nextBase,
	    initialChildComponent = component._component,
	    skip = false,
	    snapshot = previousContext,
	    rendered,
	    inst,
	    cbase;

	if (component.constructor.getDerivedStateFromProps) {
		state = extend(extend({}, state), component.constructor.getDerivedStateFromProps(props, state));
		component.state = state;
	}

	if (isUpdate) {
		component.props = previousProps;
		component.state = previousState;
		component.context = previousContext;
		if (renderMode !== 2 && component.shouldComponentUpdate && component.shouldComponentUpdate(props, state, context) === false) {
			skip = true;
		} else if (component.componentWillUpdate) {
			component.componentWillUpdate(props, state, context);
		}
		component.props = props;
		component.state = state;
		component.context = context;
	}

	component.prevProps = component.prevState = component.prevContext = component.nextBase = null;
	component._dirty = false;

	if (!skip) {
		rendered = component.render(props, state, context);

		if (component.getChildContext) {
			context = extend(extend({}, context), component.getChildContext());
		}

		if (isUpdate && component.getSnapshotBeforeUpdate) {
			snapshot = component.getSnapshotBeforeUpdate(previousProps, previousState);
		}

		var childComponent = rendered && rendered.nodeName,
		    toUnmount,
		    base;

		if (typeof childComponent === 'function') {

			var childProps = getNodeProps(rendered);
			inst = initialChildComponent;

			if (inst && inst.constructor === childComponent && childProps.key == inst.__key) {
				setComponentProps(inst, childProps, 1, context, false);
			} else {
				toUnmount = inst;

				component._component = inst = createComponent(childComponent, childProps, context);
				inst.nextBase = inst.nextBase || nextBase;
				inst._parentComponent = component;
				setComponentProps(inst, childProps, 0, context, false);
				renderComponent(inst, 1, mountAll, true);
			}

			base = inst.base;
		} else {
			cbase = initialBase;

			toUnmount = initialChildComponent;
			if (toUnmount) {
				cbase = component._component = null;
			}

			if (initialBase || renderMode === 1) {
				if (cbase) cbase._component = null;
				base = diff(cbase, rendered, context, mountAll || !isUpdate, initialBase && initialBase.parentNode, true);
			}
		}

		if (initialBase && base !== initialBase && inst !== initialChildComponent) {
			var baseParent = initialBase.parentNode;
			if (baseParent && base !== baseParent) {
				baseParent.replaceChild(base, initialBase);

				if (!toUnmount) {
					initialBase._component = null;
					recollectNodeTree(initialBase, false);
				}
			}
		}

		if (toUnmount) {
			unmountComponent(toUnmount);
		}

		component.base = base;
		if (base && !isChild) {
			var componentRef = component,
			    t = component;
			while (t = t._parentComponent) {
				(componentRef = t).base = base;
			}
			base._component = componentRef;
			base._componentConstructor = componentRef.constructor;
		}
	}

	if (!isUpdate || mountAll) {
		mounts.push(component);
	} else if (!skip) {

		if (component.componentDidUpdate) {
			component.componentDidUpdate(previousProps, previousState, snapshot);
		}
		if (options.afterUpdate) options.afterUpdate(component);
	}

	while (component._renderCallbacks.length) {
		component._renderCallbacks.pop().call(component);
	}if (!diffLevel && !isChild) flushMounts();
}

function buildComponentFromVNode(dom, vnode, context, mountAll) {
	var c = dom && dom._component,
	    originalComponent = c,
	    oldDom = dom,
	    isDirectOwner = c && dom._componentConstructor === vnode.nodeName,
	    isOwner = isDirectOwner,
	    props = getNodeProps(vnode);
	while (c && !isOwner && (c = c._parentComponent)) {
		isOwner = c.constructor === vnode.nodeName;
	}

	if (c && isOwner && (!mountAll || c._component)) {
		setComponentProps(c, props, 3, context, mountAll);
		dom = c.base;
	} else {
		if (originalComponent && !isDirectOwner) {
			unmountComponent(originalComponent);
			dom = oldDom = null;
		}

		c = createComponent(vnode.nodeName, props, context);
		if (dom && !c.nextBase) {
			c.nextBase = dom;

			oldDom = null;
		}
		setComponentProps(c, props, 1, context, mountAll);
		dom = c.base;

		if (oldDom && dom !== oldDom) {
			oldDom._component = null;
			recollectNodeTree(oldDom, false);
		}
	}

	return dom;
}

function unmountComponent(component) {
	if (options.beforeUnmount) options.beforeUnmount(component);

	var base = component.base;

	component._disable = true;

	if (component.componentWillUnmount) component.componentWillUnmount();

	component.base = null;

	var inner = component._component;
	if (inner) {
		unmountComponent(inner);
	} else if (base) {
		if (base['__preactattr_'] != null) applyRef(base['__preactattr_'].ref, null);

		component.nextBase = base;

		removeNode(base);
		recyclerComponents.push(component);

		removeChildren(base);
	}

	applyRef(component.__ref, null);
}

function Component(props, context) {
	this._dirty = true;

	this.context = context;

	this.props = props;

	this.state = this.state || {};

	this._renderCallbacks = [];
}

extend(Component.prototype, {
	setState: function setState(state, callback) {
		if (!this.prevState) this.prevState = this.state;
		this.state = extend(extend({}, this.state), typeof state === 'function' ? state(this.state, this.props) : state);
		if (callback) this._renderCallbacks.push(callback);
		enqueueRender(this);
	},
	forceUpdate: function forceUpdate(callback) {
		if (callback) this._renderCallbacks.push(callback);
		renderComponent(this, 2);
	},
	render: function render() {}
});

function render(vnode, parent, merge) {
  return diff(merge, vnode, {}, false, parent, false);
}

function createRef() {
	return {};
}

var preact = {
	h: h,
	createElement: h,
	cloneElement: cloneElement,
	createRef: createRef,
	Component: Component,
	render: render,
	rerender: rerender,
	options: options
};

/* unused harmony default export */ var _unused_webpack_default_export = (preact);

//# sourceMappingURL=preact.mjs.map


/***/ }),

/***/ 125:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__containers_App__ = __webpack_require__(126);


// Tell Babel to transform JSX into h() calls:
/** @jsx h */

var container = document.getElementById('js-personalizer-app');

if (container) {
  Object(__WEBPACK_IMPORTED_MODULE_0_preact__["c" /* render */])(Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_1__containers_App__["a" /* default */], null), container);
}

/***/ }),

/***/ 126:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_ProductsAPI__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_validate__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Content__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Preview__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Form__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Loader__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_scrollmonitor__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__woocommerce_NumberFormat__ = __webpack_require__(7);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










// Tell Babel to transform JSX into h() calls:
/** @jsx h */

/**
 * 1 - Fetch all logomatten
 * 2 - User fills in form
 * 3 - Find matching logomat based on user input (use, type and thickness)
 * 4 - Calculcate price based on matching logomat (price m2) + user input (length/width/cutter/corners)
 */

var App = function (_Component) {
  _inherits(App, _Component);

  function App(props) {
    _classCallCheck(this, App);

    var _this = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this, props));

    _this.state = {
      products: [],
      currentProduct: {},
      targetPrice: 'Vul velden in',
      fetchError: false,
      priceError: false,
      isLoading: true,
      formIsValid: false,
      sendingForm: false,
      formControls: {
        use: { //radio
          value: '',
          valid: false, //set to true if give default value
          validationRules: {
            isRequired: true
          },
          touched: false,
          error: '',
          options: [{ value: 'Binnenmatten', displayValue: 'Binnen' }, { value: 'Buitenmatten', displayValue: 'Buiten' }]
        },
        type: { //select
          value: '',
          placeholder: 'Kies een mat',
          valid: false,
          validationRules: {
            isRequired: true
          },
          touched: false,
          error: '',
          options: [] //get filled dynamically
        },
        thickness: { //radio
          value: '',
          valid: false,
          validationRules: {
            isRequired: true
          },
          touched: false,
          error: '',
          options: [] //get filled dynamically
        },
        rubberEdge: { //radio
          value: 'Nee',
          valid: true,
          validationRules: {
            isRequired: false
          },
          touched: false,
          error: '',
          options: [{ value: 'Ja', displayValue: 'Ja' }, { value: 'Nee', displayValue: 'Nee' }]
        },
        length: { //number
          value: '',
          placeholder: 'Lengte (cm)',
          valid: false,
          validationRules: {
            isRequired: true,
            minLength: 1,
            min: 1,
            max: 9999,
            step: '0.1'
          },
          touched: false,
          error: ''
        },
        width: { //number
          value: '',
          placeholder: 'Breedte (cm)',
          valid: false,
          validationRules: {
            isRequired: true,
            minLength: 1,
            min: 1,
            max: 9999,
            step: '0.1'
          },
          touched: false,
          error: ''
        },
        hasCorners: { //radio
          value: 'Nee',
          valid: true, //set to true if give default value
          validationRules: {
            isRequired: true
          },
          touched: true,
          error: '',
          options: [{ value: 'Ja', displayValue: 'Ja' }, { value: 'Nee', displayValue: 'Nee' }]
        },
        corners: { //number
          value: '0',
          placeholder: '0',
          valid: true,
          validationRules: {
            isRequired: true,
            minLength: 1,
            min: 0,
            max: 10,
            step: '1'
          },
          touched: true,
          error: ''
        },
        cutter: { //radio
          value: 'Nee',
          valid: true, //set to true if give default value
          validationRules: {
            isRequired: true
          },
          touched: true,
          error: '',
          options: [{ value: 'Ja', displayValue: 'Ja (+ 3,95)' }, { value: 'Nee', displayValue: 'Nee' }]
        },
        file: { //file
          value: '',
          fileName: '',
          valid: true,
          validationRules: {
            maxSize: '4000000' //4MB
          },
          touched: false,
          error: '',
          accept: '.doc,.docx,.pdf,.jpg,.png'
        },
        firstname: { //text
          value: '',
          placeholder: 'Voornaam*',
          valid: false,
          validationRules: {
            isRequired: true,
            minLength: 2
          },
          touched: false,
          error: ''
        },
        lastname: { //text
          value: '',
          placeholder: 'Achternaam*',
          valid: false,
          validationRules: {
            isRequired: true,
            minLength: 2
          },
          touched: false,
          error: ''
        },
        company: { //text
          value: '',
          placeholder: 'Bedrijfsnaam',
          valid: true,
          validationRules: {},
          touched: false,
          error: ''
        },
        phone: { //text
          value: '',
          placeholder: 'Telefoon*',
          valid: false,
          validationRules: {
            isRequired: true,
            minLength: 2
          },
          touched: false,
          error: ''
        },
        email: { //email
          value: '',
          placeholder: 'E-mailadres*',
          valid: false,
          validationRules: {
            isRequired: true,
            isEmail: true
          },
          touched: false,
          error: ''
        },
        address: { //text
          value: '',
          placeholder: 'Straat en huisnummer*',
          valid: false,
          validationRules: {
            isRequired: true,
            minLength: 2
          },
          touched: false,
          error: ''
        },
        zip: { //text
          value: '',
          placeholder: 'Postcode*',
          valid: false,
          validationRules: {
            isRequired: true,
            minLength: 2
          },
          touched: false,
          error: ''
        },
        city: { //text
          value: '',
          placeholder: 'Plaats*',
          valid: false,
          validationRules: {
            isRequired: true,
            minLength: 2
          },
          touched: false,
          error: ''
        },
        message: { //textarea
          value: '',
          placeholder: 'Heeft u nog opmerkingen?',
          valid: true,
          validationRules: {},
          touched: false,
          error: ''
        }
      }
    };

    _this.handleChange = _this.handleChange.bind(_this);
    _this.handleRemoveFile = _this.handleRemoveFile.bind(_this);
    _this.isMatchingProduct = _this.isMatchingProduct.bind(_this);
    _this.calculateTargetPrice = _this.calculateTargetPrice.bind(_this);
    _this.getTypeOptions = _this.getTypeOptions.bind(_this);
    _this.getThicknessOptions = _this.getThicknessOptions.bind(_this);
    _this.handleScroll = _this.handleScroll.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    return _this;
  }

  _createClass(App, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.fetchProducts();
      this.handleScroll();
    }

    /**
     * Fetch all logo matten
     */

  }, {
    key: 'fetchProducts',
    value: function fetchProducts() {
      var _this2 = this;

      this.setState({ isLoading: true });

      __WEBPACK_IMPORTED_MODULE_1__api_ProductsAPI__["a" /* default */].all().then(function (response) {
        return response.json();
      }).then(function (data) {
        _this2.setState({
          products: [].concat(_toConsumableArray(_this2.state.products), _toConsumableArray(data)),
          isLoading: false
        });
      }).catch(function (error) {
        _this2.setState({
          fetchError: true,
          isLoading: false
        });
        throw Error('Fetching products failed: ' + error);
      });
    }

    /**
     * Handle scroll
     */

  }, {
    key: 'handleScroll',
    value: function handleScroll() {
      var monitor = document.querySelector('.js-personalizer-preview');
      var watcher = __WEBPACK_IMPORTED_MODULE_7_scrollmonitor__["a" /* default */].create(monitor);

      watcher.lock(); // ensure that we're always watching the place the element originally was

      watcher.stateChange(function () {
        if (watcher.isInViewport || !watcher.isInViewport && watcher.isBelowViewport) {
          if (monitor.classList.contains('active')) {
            monitor.classList.remove('active');
          }
        } else {
          if (!monitor.classList.contains('active')) {
            monitor.classList.add('active');
          }
        }
      });
    }

    /**
     * Handle form submit
     */

  }, {
    key: 'handleSubmit',
    value: function handleSubmit(e) {
      var _this3 = this;

      e.preventDefault();
      this.setState({
        sendingForm: true
      });
      window.fetch('/wordpress/wp-admin/admin-ajax.php?action=send_form', {
        credentials: 'same-origin',
        method: 'post',
        body: new window.FormData(e.target)
      }).then(function (response) {
        return response.json();
      }).then(function (r) {
        window.dataLayer.push({
          'event': 'personalizeDoorMat',
          'product': _this3.state.currentProduct.title,
          'price': _this3.state.targetPrice,
          'thickness': _this3.state.formControls.thickness.value,
          'rubberEdge': _this3.state.formControls.rubberEdge.value
        });
        setTimeout(function () {
          window.location = '/zakelijk/mat-personaliseren/bedankt/';
        }, 1000);
      });
    }

    /**
     * Handle form changes
     */

  }, {
    key: 'handleChange',
    value: function handleChange(e) {

      // Grab the current form element
      var name = e.target.name;
      var value = e.target.value;
      var files = e.target.files;
      var fileName = files && files.length > 0 ? files[0].name : '';
      var updatedControls = _extends({}, this.state.formControls);
      var updatedFormElement = _extends({}, updatedControls[name]);

      // Update the current form element
      var validation = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_validate__["a" /* default */])(value, files, updatedFormElement.validationRules);
      updatedFormElement.value = value;
      updatedFormElement.valid = validation.status;
      updatedFormElement.error = validation.message;
      updatedFormElement.touched = true;
      if (fileName) {
        updatedFormElement.fileName = fileName;
      }
      updatedControls[name] = updatedFormElement;

      /**
       * Reset 'type' if new 'use' has been chosen, 
       * because the type options will be recreated dynamically.
       */
      if (name === 'use') {
        updatedControls.type.value = '';
        updatedControls.type.valid = false;
        updatedControls.type.touched = false;
        updatedControls.type.options = [];
      }

      /**
       * Reset 'thickness' if new 'use' or 'type' has been chosen, 
       * because the thickness options will be recreated dynamically.
       */
      if (name === 'use' || name === 'type') {
        updatedControls.thickness.value = '';
        updatedControls.thickness.valid = false;
        updatedControls.thickness.touched = false;
        updatedControls.thickness.options = [];
      }

      /**
       * Loop through all form controls valid status, 
       * to determine whether form is valid or not.
       */
      var formIsValid = true;

      for (var el in updatedControls) {
        formIsValid = updatedControls[el].valid && formIsValid;
      }

      // Set new state
      this.setState({
        formControls: updatedControls,
        formIsValid: formIsValid
      });

      /**
       * Try to find a matching product based on user input,
       * and calculate target price afterwards
       */
      this.findMatchingProduct();

      /**
       * Find type select options based on user input (use)
       */
      this.getTypeOptions();
      this.getThicknessOptions();
    }

    /**
     * Handle removal of file value
     * if click 'verwijderen'.
     */

  }, {
    key: 'handleRemoveFile',
    value: function handleRemoveFile() {
      var formControls = this.state.formControls;
      formControls.file.value = '';
      formControls.file.valid = false;
      formControls.file.error = '';
      formControls.file.touched = false;

      this.setState({
        formIsValid: false,
        formControls: formControls
      });
    }

    /**
     * Find a matching mat 
     * based on the entered use, type and thickness.
     */

  }, {
    key: 'findMatchingProduct',
    value: function findMatchingProduct() {
      var _state = this.state,
          products = _state.products,
          formControls = _state.formControls;

      /**
       * Return empty object 
       * if user has NOT entered all required values to find a match
       */

      if (formControls.use.value === '' || formControls.type.value === '' || formControls.thickness.value === '') {
        return this.setState({
          currentProduct: {},
          targetPrice: 'Geen product match'
        });
      }

      /**
       * Return matching product object OR empty object 
       * if user has entereed all required values to find a match
       */
      var currentProduct = products.find(this.isMatchingProduct) ? products.find(this.isMatchingProduct) : {};

      this.setState(function () {
        return {
          currentProduct: currentProduct
        };
      }, this.calculateTargetPrice);
    }

    /**
     * Check if there's a product match
     * based on the entered use, type and thickness.
     * 
     * @return boolean
     */

  }, {
    key: 'isMatchingProduct',
    value: function isMatchingProduct(product) {
      var formControls = this.state.formControls;


      var use = product.use.includes(formControls.use.value);
      var type = product.type.includes(formControls.type.value);
      var thickness = product.thickness.includes(formControls.thickness.value);

      return use && type && thickness;
    }

    /**
     * Calculate target price
     */

  }, {
    key: 'calculateTargetPrice',
    value: function calculateTargetPrice() {
      var _state2 = this.state,
          currentProduct = _state2.currentProduct,
          formControls = _state2.formControls;

      /**
       * If no matching product
       */

      if (!currentProduct.id) {
        return this.setState({
          targetPrice: 'Geen product match'
        });
      }

      var price = currentProduct.price;
      var cutterPrice = currentProduct.cutter_price;
      var cornerPrice = currentProduct.corner_price;

      /**
       * If product lacks a price.
       */
      if (!price) {
        return this.setState({
          targetPrice: 'Op aanvraag*'
        });
      }

      /**
       * If user has NOT entered dimensions
       */
      if (formControls.length.value === '' || formControls.length.value < 1 || formControls.width.value === '' || formControls.width.value < 1) {
        return this.setState({
          targetPrice: 'Vul dimensies in'
        });
      }

      /**
       * Calculate dimensions price
       */
      price = parseFloat(price);
      var length = parseFloat(formControls.length.value);
      var width = parseFloat(formControls.width.value);

      var targetPrice = length / 100 * (width / 100) * price;

      /**
      * Add cutter price if one exists
      * and if user has selected one
      */
      if (cutterPrice && formControls.cutter.valid && formControls.cutter.value === 'Ja') {
        targetPrice = targetPrice + parseFloat(cutterPrice);
      }

      /**
      * Add corner price if one exists
      * and if user has selected one
      */
      if (cornerPrice && formControls.corners.valid && formControls.corners.value !== '') {
        targetPrice = targetPrice + parseFloat(cornerPrice) * parseFloat(formControls.corners.value);
      }

      // Return error if invalid price
      if (Object(__WEBPACK_IMPORTED_MODULE_8__woocommerce_NumberFormat__["a" /* numberFormat */])(targetPrice, 2, ',', '.') === '0,00') {
        this.setState({
          targetPrice: 'Prijs kon niet berekend worden.',
          priceError: true
        });
        throw Error('Price failed to calculate: returned 0,00');
      }

      // Set price
      this.setState({
        targetPrice: Object(__WEBPACK_IMPORTED_MODULE_8__woocommerce_NumberFormat__["a" /* numberFormat */])(targetPrice, 2, ',', '.')
      });
    }

    /**
     * Build the formControls.type options
     * based on user input.
     */

  }, {
    key: 'getTypeOptions',
    value: function getTypeOptions() {
      var _state3 = this.state,
          products = _state3.products,
          formControls = _state3.formControls;

      // Return early if user has NOT entered required formControls.use

      if (formControls.use.value === '') return;

      // Return product with a matching 'use'
      var matchingProducts = products.filter(function (product) {
        return product.use.includes(formControls.use.value);
      });

      /**
       * Build all formControls.type options from the matching products
       */
      var types = matchingProducts.map(function (product) {
        return product.type;
      }); //has duplicates
      var uniqueTypes = [].concat(_toConsumableArray(new Set(types.flat()))); //remove duplicates
      var options = [];[].concat(_toConsumableArray(uniqueTypes)).forEach(function (type) {
        options.push({
          value: type, displayValue: type
        });
      });

      /**
       * Set new formControls.type options 
       */
      formControls.type.options = options;
      this.setState({ formControls: formControls });
    }

    /**
     * Build the formControls.thickness options
     * based on user input.
     */

  }, {
    key: 'getThicknessOptions',
    value: function getThicknessOptions() {
      var _state4 = this.state,
          products = _state4.products,
          formControls = _state4.formControls;

      // Return early if user has NOT entered required formControls.type

      if (formControls.type.value === '') return;

      // Return product with a matching 'type'
      var matchingProducts = products.filter(function (product) {
        return product.type.includes(formControls.type.value);
      });

      /**
       * Build all formControls.thickness options from the matching products
       */
      var thicknesses = matchingProducts.map(function (product) {
        return product.thickness;
      }); //has duplicates
      var uniqueThicknesses = [].concat(_toConsumableArray(new Set(thicknesses.flat()))); //remove duplicates
      var options = [];[].concat(_toConsumableArray(uniqueThicknesses)).forEach(function (thickness) {
        options.push({
          value: thickness, displayValue: thickness + ' mm'
        });
      });

      /**
       * Set new formControls.type options 
       */
      formControls.thickness.options = options;
      this.setState({ formControls: formControls });
    }

    /**
     * Render
     */

  }, {
    key: 'render',
    value: function render() {
      var _state5 = this.state,
          formIsValid = _state5.formIsValid,
          formControls = _state5.formControls,
          currentProduct = _state5.currentProduct,
          isLoading = _state5.isLoading,
          fetchError = _state5.fetchError,
          priceError = _state5.priceError,
          targetPrice = _state5.targetPrice,
          sendingForm = _state5.sendingForm;

      return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        'div',
        { className: 'c-personalizer u-flex u-flex-sb' },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
          'div',
          { className: 'c-personalizer__left' },
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_3__components_Content__["a" /* default */], null),
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_4__components_Preview__["a" /* default */], {
            product: currentProduct,
            formControls: formControls,
            targetPrice: targetPrice
          })
        ),
        fetchError ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
          'div',
          { className: 'c-personalizer__right' },
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
            'div',
            { 'class': 'c-personalizer__app-error' },
            'App kon niet geladen worden. Ververs a.u.b. de pagina.'
          )
        ) : null,
        priceError ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
          'div',
          { className: 'c-personalizer__right' },
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
            'div',
            { 'class': 'c-personalizer__app-error' },
            'Er is iets misgegaan met de prijsberekening. Ververs a.u.b. de pagina.'
          )
        ) : null,
        !fetchError && !priceError ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
          'div',
          { className: 'c-personalizer__right' },
          isLoading ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_6__components_Loader__["a" /* default */], null) : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_5__components_Form__["a" /* default */], {
            formControls: formControls,
            formIsValid: formIsValid,
            currentProduct: currentProduct,
            targetPrice: targetPrice,
            handleChange: this.handleChange,
            handleRemoveFile: this.handleRemoveFile,
            handleSubmit: this.handleSubmit,
            sendingForm: sendingForm
          })
        ) : null
      );
    }
  }]);

  return App;
}(__WEBPACK_IMPORTED_MODULE_0_preact__["a" /* Component */]);

/* harmony default export */ __webpack_exports__["a"] = (App);

/** https://medium.com/@agoiabeladeyemi/the-complete-guide-to-forms-in-react-d2ba93f32825 */

/***/ }),

/***/ 127:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ProductsAPI = function () {
  function ProductsAPI() {
    _classCallCheck(this, ProductsAPI);
  }

  _createClass(ProductsAPI, null, [{
    key: 'all',
    value: function all() {
      var url = '/wp-json/mattador/v1/logomatten';

      return fetch(url, {
        credentials: 'same-origin'
      }).then(this.handleStatus);
    }
  }, {
    key: 'handleStatus',
    value: function handleStatus(response) {
      if (!response.ok) {
        // Fetch doesn't reject on HTTP error status
        throw Error('Request rejected with status ' + response.status);
      }
      return response;
    }
  }]);

  return ProductsAPI;
}();

/* harmony default export */ __webpack_exports__["a"] = (ProductsAPI);

/***/ }),

/***/ 128:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);

// Tell Babel to transform JSX into h() calls:
/** @jsx h */

var validate = function validate(value, files, rules) {
  var isValid = true;
  var message = '';

  for (var rule in rules) {

    switch (rule) {
      case 'isRequired':
        isValid = isValid && requiredValidator(value);
        message = isValid ? '' : 'Dit veld is verplicht.';
        break;

      case 'minLength':
        isValid = isValid && minLengthValidator(value, rules[rule]);
        message = isValid ? '' : 'Minimaal ' + rules[rule] + ' karakters.';
        break;

      case 'isEmail':
        isValid = isValid && emailValidator(value);
        message = isValid ? '' : 'Vul een geldig e-mailadres in.';
        break;

      case 'min':
        isValid = isValid && minValidator(value, rules[rule]);
        message = isValid ? '' : 'Het minimum is ' + rules[rule] + '.';
        break;

      case 'max':
        isValid = isValid && maxValidator(value, rules[rule]);
        message = isValid ? '' : 'Het maximum is ' + rules[rule] + '.';
        break;

      case 'step':
        isValid = isValid && stepValidator(value, rules[rule]);
        message = isValid ? '' : 'Ongeldig getal format.';
        break;

      case 'maxSize':
        isValid = isValid && maxSizeValidator(files, rules[rule]);
        var mbs = rules[rule] / 1000000;
        message = isValid ? '' : 'Het bestand is te groot. De maximale grootte is ' + mbs + ' MB.';
        break;

      default:
        isValid = true;
        message = '';
    }

    // Break the loop once we hit invalid
    if (!isValid) {
      return {
        'status': isValid,
        'message': message
      };
    }
  }

  return {
    'status': isValid,
    'message': message
  };
};

/**
 * Check if field is required    
 */
var requiredValidator = function requiredValidator(value) {
  return value.trim() !== '';
};

/**
 * Check if value is long enough       
 */
var minLengthValidator = function minLengthValidator(value, minLength) {
  return value.length >= minLength;
};

/**
 * Check if email is valid
 */
var emailValidator = function emailValidator(value) {
  var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(value).toLowerCase());
};

/**
 * Check if value is low enough      
 */
var minValidator = function minValidator(value, min) {
  return Number(value) >= min;
};

/**
 * Check if value is high enough       
 */
var maxValidator = function maxValidator(value, max) {
  return Number(value) <= max;
};

/**
 * Check step for number input      
 */
var stepValidator = function stepValidator(value, step) {
  var number = Number(value);

  /**
   * We do allow zero, in case we have the rule min=0.
   * We'll handle zero in minValidator.
   */
  if (number === 0) {
    return true;
  }

  // Check if valid number
  if (!number) {
    return false;
  }

  // If step integers only
  if (step === '1') {
    return Number.isInteger(number);
  }

  return number;
};

/**
 * Check if value size is low enough   
 */
var maxSizeValidator = function maxSizeValidator(files, maxSize) {
  return files.length > 0 && files[0].size <= maxSize;
};

/* harmony default export */ __webpack_exports__["a"] = (validate);

/***/ }),

/***/ 129:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);

// Tell Babel to transform JSX into h() calls:
/** @jsx h */

var Content = function Content(props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
    "div",
    { className: "c-personalizer__content-container c-list" },
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
      "h1",
      null,
      "Mat personaliseren"
    ),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
      "p",
      null,
      "Stel hier gemakkelijk je mat samen en ontvang een vrijblijvende richtprijs."
    ),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
      "ul",
      { className: "checked" },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        "li",
        null,
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
          "strong",
          null,
          "Gratis"
        ),
        " digitale proefdruk"
      ),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        "li",
        null,
        "Altijd ",
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
          "strong",
          null,
          "gratis"
        ),
        " verzending"
      ),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        "li",
        null,
        "Ontvang een ",
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
          "strong",
          null,
          "offerte"
        ),
        " op maat"
      ),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        "li",
        null,
        "Persoonlijk ",
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
          "strong",
          null,
          "advies"
        )
      ),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        "li",
        null,
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
          "strong",
          null,
          "Maatwerk"
        ),
        " op de mm nauwkeurig"
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Content);

/***/ }),

/***/ 130:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_OrderTable__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_OrderPrice__ = __webpack_require__(25);

// Tell Babel to transform JSX into h() calls:
/** @jsx h */




var Preview = function Preview(props) {
  var formControls = props.formControls,
      product = props.product,
      targetPrice = props.targetPrice;


  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
    'div',
    { className: 'c-personalizer-preview js-personalizer-preview' },
    product.id ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
      'div',
      { className: 'c-personalizer-preview__container' },
      product.image ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('div', { className: 'c-personalizer-preview__image u-image', dangerouslySetInnerHTML: { __html: product.image } }) : null,
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        'p',
        { className: 'c-personalizer-row__title' },
        'Overzicht'
      ),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_1__components_OrderTable__["a" /* default */], { formControls: formControls }),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_2__components_OrderPrice__["a" /* default */], { targetPrice: targetPrice })
    ) : null
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Preview);

/***/ }),

/***/ 131:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_CardCompile__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_CardCorners__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_CardUpload__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_CardUser__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Order__ = __webpack_require__(141);

// Tell Babel to transform JSX into h() calls:
/** @jsx h */







var Form = function Form(props) {
  var formIsValid = props.formIsValid,
      formControls = props.formControls,
      currentProduct = props.currentProduct,
      targetPrice = props.targetPrice,
      handleChange = props.handleChange,
      handleRemoveFile = props.handleRemoveFile,
      handleSubmit = props.handleSubmit,
      sendingForm = props.sendingForm;


  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
    'div',
    { className: 'c-personalizer__form-container' },
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
      'form',
      { method: 'post', enctype: 'multipart/form-data', action: '/mat-personaliseren/bedankt/', onSubmit: handleSubmit },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('input', { type: 'hidden', name: 'form_id', value: '99999' }),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('input', { type: 'hidden', name: 'form_title', value: 'Mat personaliseren' }),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('input', { type: 'hidden', name: 'page', value: 'Mat samenstellen' }),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('input', { type: 'hidden', name: 'url', value: window.location.href }),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('input', { type: 'hidden', name: 'hubspot_form', value: 'f719a762-c3aa-4c92-a2ac-e65bd32f7b46' }),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('input', { type: 'text', name: 'first_name', value: '', className: 'u-obscure', placeholder: 'Laat dit veld leeg' }),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('input', { type: 'hidden', name: 'targetPrice', value: targetPrice }),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_1__components_CardCompile__["a" /* default */], {
        formControls: formControls,
        handleChange: handleChange,
        product: currentProduct
      }),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_2__components_CardCorners__["a" /* default */], {
        formControls: formControls,
        handleChange: handleChange
      }),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_3__components_CardUpload__["a" /* default */], {
        formControls: formControls,
        handleChange: handleChange,
        handleRemoveFile: handleRemoveFile
      }),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_4__components_CardUser__["a" /* default */], {
        formControls: formControls,
        handleChange: handleChange
      }),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_5__components_Order__["a" /* default */], {
        formControls: formControls,
        product: currentProduct,
        formIsValid: formIsValid,
        targetPrice: targetPrice,
        sendingForm: sendingForm
      })
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Form);

/***/ }),

/***/ 132:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_input_Radio__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_input_Select__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_input_Number__ = __webpack_require__(27);

// Tell Babel to transform JSX into h() calls:
/** @jsx h */





var CardCompile = function CardCompile(props) {
  var formControls = props.formControls,
      handleChange = props.handleChange,
      product = props.product;


  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
    'div',
    { className: 'c-personalizer-card' },
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
      'div',
      { className: 'c-personalizer-card__header' },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        'h3',
        { className: 'c-personalizer-card__title' },
        '1. Stel je mat samen'
      )
    ),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
      'div',
      { 'class': 'c-personalizer-row' },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        'p',
        { 'class': 'c-personalizer-row__title' },
        'Waar komt je mat te liggen?'
      ),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_1__components_input_Radio__["a" /* default */], { name: 'use',
        value: formControls.use.value,
        onChange: handleChange,
        options: formControls.use.options,
        touched: formControls.use.touched,
        valid: formControls.use.valid,
        error: formControls.use.error
      })
    ),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
      'div',
      { 'class': 'c-personalizer-row' },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        'p',
        { 'class': 'c-personalizer-row__title' },
        'Welke mat past bij jou?'
      ),
      formControls.use.value ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_2__components_input_Select__["a" /* default */], { name: 'type',
        placeholder: formControls.type.placeholder,
        value: formControls.type.value,
        onChange: handleChange,
        options: formControls.type.options,
        touched: formControls.type.touched,
        valid: formControls.type.valid,
        error: formControls.type.error
      }) : null,
      formControls.type.value ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        'div',
        null,
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
          'p',
          { 'class': 'c-personalizer-row__label' },
          'Matdikte'
        ),
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_1__components_input_Radio__["a" /* default */], { name: 'thickness',
          value: formControls.thickness.value,
          onChange: handleChange,
          options: formControls.thickness.options,
          touched: formControls.thickness.touched,
          valid: formControls.thickness.valid,
          error: formControls.thickness.error
        })
      ) : null,
      product && product.price === '' ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        'p',
        { className: 'c-personalizer-row__message' },
        'Let op. Vanwege de specificaties van deze mat is het niet mogelijk een richtprijs aan te geven. Je ontvangt de vrijblijvende prijs na aanvraag.'
      ) : null,
      formControls.thickness.value && product && product.rubber_edge.includes('Ja') ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        'div',
        null,
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
          'p',
          { 'class': 'c-personalizer-row__label' },
          'Randafwerking toevoegen?'
        ),
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
          'p',
          { 'class': 'c-personalizer-row__comment c-personalizer-row__comment--option' },
          'Komt de mat in een uitsparing in de vloer te liggen? Selecteer dan \'Nee\'.'
        ),
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_1__components_input_Radio__["a" /* default */], { name: 'rubberEdge',
          value: formControls.rubberEdge.value,
          onChange: handleChange,
          options: formControls.rubberEdge.options,
          touched: formControls.rubberEdge.touched,
          valid: formControls.rubberEdge.valid,
          error: formControls.rubberEdge.error
        })
      ) : null
    ),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
      'div',
      { 'class': 'c-personalizer-row' },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        'p',
        { 'class': 'c-personalizer-row__title' },
        'Afmetingen'
      ),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        'p',
        { 'class': 'c-personalizer-row__comment' },
        'In cm tot 1 getal na de komma, bijv. 68,1 cm bij 100,2 cm.'
      ),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        'div',
        { 'class': 'u-flex u-flex-sb c-personalizer-row__row' },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
          'div',
          { 'class': 'c-personalizer-row__col' },
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_3__components_input_Number__["a" /* default */], { name: 'length',
            placeholder: formControls.length.placeholder,
            value: formControls.length.value,
            onChange: handleChange,
            touched: formControls.length.touched,
            valid: formControls.length.valid,
            step: formControls.length.validationRules.step,
            error: formControls.length.error
          })
        ),
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
          'div',
          { 'class': 'c-personalizer-row__col' },
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_3__components_input_Number__["a" /* default */], { name: 'width',
            placeholder: formControls.width.placeholder,
            value: formControls.width.value,
            onChange: handleChange,
            touched: formControls.width.touched,
            valid: formControls.width.valid,
            step: formControls.width.validationRules.step,
            error: formControls.width.error
          })
        )
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (CardCompile);

/***/ }),

/***/ 133:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);

// Tell Babel to transform JSX into h() calls:
/** @jsx h */

var Select = function Select(props) {

  var inputClass = 'c-personalizer-group__select';

  if (props.touched && !props.valid) {
    inputClass = 'c-personalizer-group__select c-personalizer-group__error';
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
    'div',
    { className: 'c-personalizer-group c-personalizer-group--select' },
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
      'select',
      { className: inputClass, value: props.value, onChange: props.onChange, name: props.name },
      props.placeholder ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        'option',
        { value: '', disabled: true },
        props.placeholder
      ) : null,
      props.options.map(function (option) {
        return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
          'option',
          { value: option.value, selected: option.value === props.value },
          option.displayValue
        );
      })
    ),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
      'p',
      { 'class': 'c-personalizer-group__error-message' },
      props.error
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Select);

/***/ }),

/***/ 134:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__input_Radio__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__input_Number__ = __webpack_require__(27);

// Tell Babel to transform JSX into h() calls:
/** @jsx h */




var CardCorners = function CardCorners(props) {
  var formControls = props.formControls,
      handleChange = props.handleChange;


  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
    'div',
    { className: 'c-personalizer-card' },
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
      'div',
      { className: 'c-personalizer-card__header' },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        'h3',
        { className: 'c-personalizer-card__title' },
        '2. Uitsnedes'
      )
    ),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
      'div',
      { 'class': 'c-personalizer-row' },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        'p',
        { 'class': 'c-personalizer-row__title' },
        'Moet de mat worden bijgesneden?'
      ),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        'p',
        { 'class': 'c-personalizer-row__comment' },
        'Telefonisch bespreken we de precieze hoeken zodat de mat straks op de mm nauwkeurig past. Als we de hoeken vooraf in kunnen snijden zijn de kosten per hoek gemiddeld 9,075 euro (inclusief btw). Als we de mat niet vooraf kunnen insnijden geven we je graag een prijs voor het leggen van de mat bij jouw op locatie. Je kunt er ook voor kiezen zelf de mat bij te snijden door ons mattenmes van 3,95 euro (inclusief btw) te kopen in de volgende stap.'
      ),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_1__input_Radio__["a" /* default */], { name: 'hasCorners',
        value: formControls.hasCorners.value,
        onChange: handleChange,
        options: formControls.hasCorners.options,
        touched: formControls.hasCorners.touched,
        valid: formControls.hasCorners.valid,
        error: formControls.hasCorners.error
      }),
      formControls.hasCorners.value === 'Ja' ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        'div',
        null,
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
          'p',
          { 'class': 'c-personalizer-row__label' },
          'Schatting aantal uitsneden'
        ),
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
          'div',
          { 'class': 'c-personalizer-row__max-width' },
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_2__input_Number__["a" /* default */], { name: 'corners',
            placeholder: formControls.corners.placeholder,
            value: formControls.corners.value,
            onChange: handleChange,
            touched: formControls.corners.touched,
            valid: formControls.corners.valid,
            step: formControls.corners.validationRules.step,
            error: formControls.corners.error
          })
        )
      ) : null
    ),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
      'div',
      { 'class': 'c-personalizer-row' },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        'p',
        { 'class': 'c-personalizer-row__title' },
        'Snijmes toevoegen'
      ),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        'p',
        { 'class': 'c-personalizer-row__comment' },
        'Snij eenvoudig en snel je mat op maat met ons mattenmes.'
      ),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_1__input_Radio__["a" /* default */], { name: 'cutter',
        value: formControls.cutter.value,
        onChange: handleChange,
        options: formControls.cutter.options,
        touched: formControls.cutter.touched,
        valid: formControls.cutter.valid,
        error: formControls.cutter.error
      })
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (CardCorners);

/***/ }),

/***/ 135:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__input_Upload__ = __webpack_require__(136);

// Tell Babel to transform JSX into h() calls:
/** @jsx h */



var CardUpload = function CardUpload(props) {
  var formControls = props.formControls,
      handleChange = props.handleChange,
      handleRemoveFile = props.handleRemoveFile;


  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
    'div',
    { className: 'c-personalizer-card' },
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
      'div',
      { className: 'c-personalizer-card__header' },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        'h3',
        { className: 'c-personalizer-card__title' },
        '3. Opdruk toevoegen'
      )
    ),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
      'div',
      { 'class': 'c-personalizer-row' },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        'p',
        { 'class': 'c-personalizer-row__explain' },
        'Voeg je logo of afbeelding toe. Indien de afbeelding niet goed uitkomt of van onvoldoende kwaliteit is nemen wij direct contact op.'
      ),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_1__input_Upload__["a" /* default */], { name: 'file',
        value: formControls.file.value,
        onChange: handleChange,
        touched: formControls.file.touched,
        valid: formControls.file.valid,
        accept: formControls.file.accept,
        onRemoveFile: handleRemoveFile,
        error: formControls.file.error,
        fileName: formControls.file.fileName
      }),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        'p',
        { 'class': 'c-personalizer-row__notice' },
        'Geen opdruk bij de hand? Je mag deze ook later opsturen.'
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (CardUpload);

/***/ }),

/***/ 136:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };


// Tell Babel to transform JSX into h() calls:
/** @jsx h */

var Upload = function Upload(props) {
  var inputClass = 'c-personalizer-group__upload c-upload__input';

  function handleRemove(e) {
    props.onRemoveFile();
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
    'div',
    { className: 'c-personalizer-group c-personalizer-group--upload c-upload' },
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
      'div',
      { className: 'c-upload__container' },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        'div',
        { className: 'c-upload__content' },
        props.value && props.fileName ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
          'span',
          null,
          props.fileName
        ) : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
          'span',
          null,
          'Selecteer een bestand'
        )
      ),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        'div',
        { className: 'c-upload__button' },
        'Uploaden'
      ),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('input', _extends({ type: 'file', className: inputClass, accept: '.doc,.docx,.pdf,.jpg,.png' }, props))
    ),
    props.value ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
      'div',
      { className: 'c-personalizer-upload__remove', onClick: handleRemove },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        'svg',
        { 'class': 'c-icon c-personalizer-upload__icon' },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('use', { href: '#cross-dicht', xlinkHref: '#cross-dicht' })
      ),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        'span',
        null,
        'Verwijder'
      )
    ) : null,
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
      'p',
      { 'class': 'c-personalizer-group__error-message' },
      props.error
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Upload);

/***/ }),

/***/ 137:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__input_TextInput__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__input_Email__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__input_TextArea__ = __webpack_require__(140);

// Tell Babel to transform JSX into h() calls:
/** @jsx h */





var CardUser = function CardUser(props) {
  var formControls = props.formControls,
      handleChange = props.handleChange;


  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
    'div',
    { className: 'c-personalizer-card' },
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
      'div',
      { className: 'c-personalizer-card__header' },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        'h3',
        { className: 'c-personalizer-card__title' },
        '4. Contactgegevens'
      )
    ),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
      'div',
      { 'class': 'c-personalizer-row' },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        'p',
        { 'class': 'c-personalizer-row__title' },
        'Jouw contactgegevens'
      ),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        'div',
        { 'class': 'c-personalizer-row__wide' },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
          'div',
          { 'class': 'u-flex u-flex-sb' },
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
            'div',
            { 'class': 'c-personalizer-row__col' },
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_1__input_TextInput__["a" /* default */], { name: 'firstname',
              placeholder: formControls.firstname.placeholder,
              value: formControls.firstname.value,
              onChange: handleChange,
              touched: formControls.firstname.touched,
              valid: formControls.firstname.valid,
              error: formControls.firstname.error
            })
          ),
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
            'div',
            { 'class': 'c-personalizer-row__col' },
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_1__input_TextInput__["a" /* default */], { name: 'lastname',
              placeholder: formControls.lastname.placeholder,
              value: formControls.lastname.value,
              onChange: handleChange,
              touched: formControls.lastname.touched,
              valid: formControls.lastname.valid,
              error: formControls.lastname.error
            })
          )
        ),
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_1__input_TextInput__["a" /* default */], { name: 'company',
          placeholder: formControls.company.placeholder,
          value: formControls.company.value,
          onChange: handleChange,
          touched: formControls.company.touched,
          valid: formControls.company.valid,
          error: formControls.company.error
        }),
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
          'div',
          { 'class': 'u-flex u-flex-sb' },
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
            'div',
            { 'class': 'c-personalizer-row__col' },
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_1__input_TextInput__["a" /* default */], { name: 'phone',
              placeholder: formControls.phone.placeholder,
              value: formControls.phone.value,
              onChange: handleChange,
              touched: formControls.phone.touched,
              valid: formControls.phone.valid,
              error: formControls.phone.error
            })
          ),
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
            'div',
            { 'class': 'c-personalizer-row__col' },
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_2__input_Email__["a" /* default */], { name: 'email',
              placeholder: formControls.email.placeholder,
              value: formControls.email.value,
              onChange: handleChange,
              touched: formControls.email.touched,
              valid: formControls.email.valid,
              error: formControls.email.error
            })
          )
        ),
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_1__input_TextInput__["a" /* default */], { name: 'address',
          placeholder: formControls.address.placeholder,
          value: formControls.address.value,
          onChange: handleChange,
          touched: formControls.address.touched,
          valid: formControls.address.valid,
          error: formControls.address.error
        }),
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
          'div',
          { 'class': 'u-flex u-flex-sb' },
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
            'div',
            { 'class': 'c-personalizer-row__col' },
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_1__input_TextInput__["a" /* default */], { name: 'zip',
              placeholder: formControls.zip.placeholder,
              value: formControls.zip.value,
              onChange: handleChange,
              touched: formControls.zip.touched,
              valid: formControls.zip.valid,
              error: formControls.zip.error
            })
          ),
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
            'div',
            { 'class': 'c-personalizer-row__col' },
            Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_1__input_TextInput__["a" /* default */], { name: 'city',
              placeholder: formControls.city.placeholder,
              value: formControls.city.value,
              onChange: handleChange,
              touched: formControls.city.touched,
              valid: formControls.city.valid,
              error: formControls.city.error
            })
          )
        ),
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_3__input_TextArea__["a" /* default */], { name: 'message',
          placeholder: formControls.message.placeholder,
          value: formControls.message.value,
          onChange: handleChange,
          touched: formControls.message.touched,
          valid: formControls.message.valid,
          error: formControls.message.error
        })
      )
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (CardUser);

/***/ }),

/***/ 138:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };


// Tell Babel to transform JSX into h() calls:
/** @jsx h */

var TextInput = function TextInput(props) {

  var inputClass = 'c-personalizer-group__text-input';

  if (props.touched && !props.valid) {
    inputClass = 'c-personalizer-group__text-input c-personalizer-group__error';
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
    'div',
    { className: 'c-personalizer-group' },
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('input', _extends({ type: 'text', className: inputClass }, props)),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
      'p',
      { 'class': 'c-personalizer-group__error-message' },
      props.error
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (TextInput);

/***/ }),

/***/ 139:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };


// Tell Babel to transform JSX into h() calls:
/** @jsx h */

var Email = function Email(props) {

  var inputClass = 'c-personalizer-group__email';

  if (props.touched && !props.valid) {
    inputClass = 'c-personalizer-group__email c-personalizer-group__error';
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
    'div',
    { className: 'c-personalizer-group' },
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('input', _extends({ type: 'email', className: inputClass }, props)),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
      'p',
      { 'class': 'c-personalizer-group__error-message' },
      props.error
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Email);

/***/ }),

/***/ 140:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };


// Tell Babel to transform JSX into h() calls:
/** @jsx h */

var TextArea = function TextArea(props) {

  var inputClass = 'c-personalizer-group__textarea';

  if (props.touched && !props.valid) {
    inputClass = 'c-personalizer-group__textarea c-personalizer-group__error';
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
    'div',
    { className: 'c-personalizer-group' },
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('textarea', _extends({ className: inputClass }, props)),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
      'p',
      { 'class': 'c-personalizer-group__error-message' },
      props.error
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (TextArea);

/***/ }),

/***/ 141:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_OrderTable__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_OrderPrice__ = __webpack_require__(25);

// Tell Babel to transform JSX into h() calls:
/** @jsx h */




var Order = function Order(props) {
  var formControls = props.formControls,
      formIsValid = props.formIsValid,
      product = props.product,
      targetPrice = props.targetPrice,
      sendingForm = props.sendingForm;


  var buttonValue = sendingForm ? 'Offerte versturen...' : 'Offerte aanvragen';

  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
    'div',
    { className: 'c-personalizer-card' },
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
      'div',
      { className: 'c-personalizer-card__header' },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        'h3',
        { className: 'c-personalizer-card__title' },
        'Samenvatting'
      )
    ),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
      'div',
      { className: 'c-personalizer-row' },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        'p',
        { className: 'c-personalizer-row__title' },
        'Overzicht'
      ),
      product.id ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        'div',
        { className: 'c-personalizer-row__order-row u-flex u-flex-sb' },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
          'div',
          { className: 'c-personalizer-row__order-col c-personalizer-row__order-col--info' },
          Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_1__components_OrderTable__["a" /* default */], { formControls: formControls })
        ),
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
          'div',
          { className: 'c-personalizer-row__order-col c-personalizer-row__order-col--image' },
          product && product.image ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('div', { className: 'c-personalizer-row__order-image u-image', dangerouslySetInnerHTML: { __html: product.image } }) : null
        )
      ) : Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        'p',
        { className: 'c-personalizer-row__explain' },
        'Stel a.u.b. eerst je mat samen.'
      ),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(__WEBPACK_IMPORTED_MODULE_2__components_OrderPrice__["a" /* default */], { targetPrice: targetPrice })
    ),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
      'div',
      { className: 'c-personalizer-row' },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        'div',
        { className: 'u-flex u-flex-sb' },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
          'button',
          { type: 'submit', className: 'c-personalizer-row__button', disabled: !formIsValid || sendingForm },
          buttonValue
        ),
        targetPrice === 'Op aanvraag*' ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
          'p',
          { className: 'c-personalizer-row__order-comment' },
          '* Vanwege de specificaties van deze mat is het niet mogelijk een richtprijs aan te geven. Je ontvangt de vrijblijvende prijs na aanvraag.'
        ) : null
      ),
      !formIsValid ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        'p',
        { 'class': 'c-personalizer-group__order-error-message' },
        'Vul alle verplichte velden in om een offerteaanvraag te kunnen doen.'
      ) : null
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Order);

/***/ }),

/***/ 142:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);

// Tell Babel to transform JSX into h() calls:
/** @jsx h */

var Loader = function Loader() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
    "div",
    { className: "c-personalizer-loader" },
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])("div", { className: "rect1" }),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])("div", { className: "rect2" }),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])("div", { className: "rect3" }),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])("div", { className: "rect4" }),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])("div", { className: "rect5" })
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Loader);

/***/ }),

/***/ 2:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return VISIBILITYCHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ENTERVIEWPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FULLYENTERVIEWPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EXITVIEWPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PARTIALLYEXITVIEWPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return LOCATIONCHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return STATECHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return eventTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return isOnServer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return isInBrowser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return defaultOffsets; });
var VISIBILITYCHANGE = 'visibilityChange';
var ENTERVIEWPORT = 'enterViewport';
var FULLYENTERVIEWPORT = 'fullyEnterViewport';
var EXITVIEWPORT = 'exitViewport';
var PARTIALLYEXITVIEWPORT = 'partiallyExitViewport';
var LOCATIONCHANGE = 'locationChange';
var STATECHANGE = 'stateChange';
var eventTypes = [
    VISIBILITYCHANGE,
    ENTERVIEWPORT,
    FULLYENTERVIEWPORT,
    EXITVIEWPORT,
    PARTIALLYEXITVIEWPORT,
    LOCATIONCHANGE,
    STATECHANGE,
];
var isOnServer = typeof window === 'undefined';
var isInBrowser = !isOnServer;
var defaultOffsets = { top: 0, bottom: 0 };
//# sourceMappingURL=constants.js.map

/***/ }),

/***/ 24:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);

// Tell Babel to transform JSX into h() calls:
/** @jsx h */

var OrderTable = function OrderTable(props) {
  var formControls = props.formControls;


  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
    'div',
    { className: 'c-personalizer-product-table' },
    formControls.type.value !== '' ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
      'div',
      { className: 'c-personalizer-product-table__row u-flex' },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        'div',
        { className: 'c-personalizer-product-table__title' },
        'Soort mat'
      ),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        'div',
        { className: 'c-personalizer-product-table__content' },
        formControls.use.value,
        ' ',
        formControls.type.value
      )
    ) : null,
    formControls.thickness.value !== '' ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
      'div',
      { className: 'c-personalizer-product-table__row u-flex' },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        'div',
        { className: 'c-personalizer-product-table__title' },
        'Matdikte'
      ),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        'div',
        { className: 'c-personalizer-product-table__content' },
        formControls.thickness.value,
        ' mm'
      )
    ) : null,
    formControls.rubberEdge.value !== '' ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
      'div',
      { className: 'c-personalizer-product-table__row u-flex' },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        'div',
        { className: 'c-personalizer-product-table__title' },
        'Randafwerking'
      ),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        'div',
        { className: 'c-personalizer-product-table__content' },
        formControls.rubberEdge.value
      )
    ) : null,
    formControls.length.value !== '' ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
      'div',
      { className: 'c-personalizer-product-table__row u-flex' },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        'div',
        { className: 'c-personalizer-product-table__title' },
        'Lengte'
      ),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        'div',
        { className: 'c-personalizer-product-table__content' },
        formControls.length.value,
        ' cm'
      )
    ) : null,
    formControls.width.value !== '' ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
      'div',
      { className: 'c-personalizer-product-table__row u-flex' },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        'div',
        { className: 'c-personalizer-product-table__title' },
        'Breedte'
      ),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        'div',
        { className: 'c-personalizer-product-table__content' },
        formControls.width.value,
        ' cm'
      )
    ) : null,
    formControls.corners.value !== '' ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
      'div',
      { className: 'c-personalizer-product-table__row u-flex' },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        'div',
        { className: 'c-personalizer-product-table__title' },
        'Aantal uitsnedes'
      ),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        'div',
        { className: 'c-personalizer-product-table__content' },
        formControls.corners.value
      )
    ) : null,
    formControls.cutter.value !== '' ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
      'div',
      { className: 'c-personalizer-product-table__row u-flex' },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        'div',
        { className: 'c-personalizer-product-table__title' },
        'Snijmes toevoegen'
      ),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        'div',
        { className: 'c-personalizer-product-table__content' },
        formControls.cutter.value
      )
    ) : null,
    formControls.file.fileName !== '' ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
      'div',
      { className: 'c-personalizer-product-table__row u-flex' },
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        'div',
        { className: 'c-personalizer-product-table__title' },
        'Opdruk'
      ),
      Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        'div',
        { className: 'c-personalizer-product-table__content' },
        formControls.file.fileName
      )
    ) : null
  );
};

/* harmony default export */ __webpack_exports__["a"] = (OrderTable);

/***/ }),

/***/ 25:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);

// Tell Babel to transform JSX into h() calls:
/** @jsx h */

var OrderPrice = function OrderPrice(props) {
  var targetPrice = props.targetPrice;


  if (targetPrice === 'Vul velden in' || targetPrice === 'Geen product match' || targetPrice === 'Vul dimensies in') {
    return;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
    'div',
    null,
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
      'p',
      { className: 'c-personalizer-row__title' },
      'Richtprijs mat'
    ),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
      'div',
      { className: 'c-personalizer-row__price' },
      targetPrice,
      targetPrice !== 'Op aanvraag*' ? Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        'span',
        null,
        ' incl. btw'
      ) : null
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (OrderPrice);

/***/ }),

/***/ 26:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);

// Tell Babel to transform JSX into h() calls:
/** @jsx h */

var Radio = function Radio(props) {

  var inputClass = 'c-radio__element';

  if (props.touched && !props.valid) {
    inputClass = 'c-radio__element c-personalizer-group__error';
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
    'div',
    { className: 'c-personalizer-group c-personalizer-row__row' },
    props.options.map(function (option, index) {
      return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
        'div',
        { key: option.value, className: 'c-radio c-personalizer-row__col' },
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('input', { type: 'radio',
          name: props.name,
          value: option.value,
          onChange: props.onChange,
          checked: option.value === props.value,
          className: inputClass,
          id: props.name + index
        }),
        Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
          'label',
          { className: 'c-radio__label', 'for': props.name + index },
          option.displayValue
        )
      );
    }),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
      'p',
      { 'class': 'c-personalizer-group__error-message' },
      props.error
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Radio);

/***/ }),

/***/ 27:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_preact__ = __webpack_require__(0);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };


// Tell Babel to transform JSX into h() calls:
/** @jsx h */

var Number = function Number(props) {

  var inputClass = 'c-personalizer-group__number';

  if (props.touched && !props.valid) {
    inputClass = 'c-personalizer-group__number c-personalizer-group__error';
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
    'div',
    { className: 'c-personalizer-group' },
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])('input', _extends({ type: 'number', min: '0', className: inputClass }, props)),
    Object(__WEBPACK_IMPORTED_MODULE_0_preact__["b" /* h */])(
      'p',
      { 'class': 'c-personalizer-group__error-message' },
      props.error
    )
  );
};

/* harmony default export */ __webpack_exports__["a"] = (Number);

/***/ }),

/***/ 3:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ScrollMonitorContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__watcher_js__ = __webpack_require__(4);


function getViewportHeight(element) {
    if (__WEBPACK_IMPORTED_MODULE_0__constants_js__["k" /* isOnServer */]) {
        return 0;
    }
    if (element === document.body) {
        return window.innerHeight || document.documentElement.clientHeight;
    }
    else {
        return element.clientHeight;
    }
}
function getContentHeight(element) {
    if (__WEBPACK_IMPORTED_MODULE_0__constants_js__["k" /* isOnServer */]) {
        return 0;
    }
    if (element === document.body) {
        // jQuery approach
        // whichever is greatest
        return Math.max(document.body.scrollHeight, document.documentElement.scrollHeight, document.body.offsetHeight, document.documentElement.offsetHeight, document.documentElement.clientHeight);
    }
    else {
        return element.scrollHeight;
    }
}
function scrollTop(element) {
    if (__WEBPACK_IMPORTED_MODULE_0__constants_js__["k" /* isOnServer */]) {
        return 0;
    }
    if (element === document.body) {
        return (window.pageYOffset ||
            (document.documentElement && document.documentElement.scrollTop) ||
            document.body.scrollTop);
    }
    else {
        return element.scrollTop;
    }
}
var browserSupportsPassive = false;
if (__WEBPACK_IMPORTED_MODULE_0__constants_js__["j" /* isInBrowser */]) {
    try {
        var opts = Object.defineProperty({}, 'passive', {
            get: function () {
                browserSupportsPassive = true;
            },
        });
        window.addEventListener('test', null, opts);
    }
    catch (e) { }
}
var useCapture = browserSupportsPassive ? { capture: false, passive: true } : false;
var ScrollMonitorContainer = /** @class */ (function () {
    function ScrollMonitorContainer(item, parentWatcher) {
        this.eventTypes = __WEBPACK_IMPORTED_MODULE_0__constants_js__["i" /* eventTypes */];
        var self = this;
        this.item = item;
        this.watchers = [];
        this.viewportTop = null;
        this.viewportBottom = null;
        this.documentHeight = getContentHeight(item);
        this.viewportHeight = getViewportHeight(item);
        this.DOMListener = function () {
            ScrollMonitorContainer.prototype.DOMListener.apply(self, arguments);
        };
        if (parentWatcher) {
            this.containerWatcher = parentWatcher.create(item);
        }
        var previousDocumentHeight;
        var calculateViewportI;
        function calculateViewport() {
            self.viewportTop = scrollTop(item);
            self.viewportBottom = self.viewportTop + self.viewportHeight;
            self.documentHeight = getContentHeight(item);
            if (self.documentHeight !== previousDocumentHeight) {
                calculateViewportI = self.watchers.length;
                while (calculateViewportI--) {
                    self.watchers[calculateViewportI].recalculateLocation();
                }
                previousDocumentHeight = self.documentHeight;
            }
        }
        var updateAndTriggerWatchersI;
        function updateAndTriggerWatchers() {
            // update all watchers then trigger the events so one can rely on another being up to date.
            updateAndTriggerWatchersI = self.watchers.length;
            while (updateAndTriggerWatchersI--) {
                self.watchers[updateAndTriggerWatchersI].update();
            }
            updateAndTriggerWatchersI = self.watchers.length;
            while (updateAndTriggerWatchersI--) {
                self.watchers[updateAndTriggerWatchersI].triggerCallbacks(undefined);
            }
        }
        this.update = function () {
            calculateViewport();
            updateAndTriggerWatchers();
        };
        this.recalculateLocations = function () {
            this.documentHeight = 0;
            this.update();
        };
    }
    ScrollMonitorContainer.prototype.listenToDOM = function () {
        if (__WEBPACK_IMPORTED_MODULE_0__constants_js__["j" /* isInBrowser */]) {
            if (this.item === document.body) {
                window.addEventListener('scroll', this.DOMListener, useCapture);
            }
            else {
                this.item.addEventListener('scroll', this.DOMListener, useCapture);
            }
            window.addEventListener('resize', this.DOMListener);
            this.destroy = function () {
                if (this.item === document.body) {
                    window.removeEventListener('scroll', this.DOMListener, useCapture);
                    this.containerWatcher.destroy();
                }
                else {
                    this.item.removeEventListener('scroll', this.DOMListener, useCapture);
                }
                window.removeEventListener('resize', this.DOMListener);
            };
        }
    };
    ScrollMonitorContainer.prototype.destroy = function () {
        // noop, override for your own purposes.
        // in listenToDOM, for example.
    };
    ScrollMonitorContainer.prototype.DOMListener = function (event) {
        //alert('got scroll');
        this.updateState();
        this.updateAndTriggerWatchers(event);
    };
    ScrollMonitorContainer.prototype.updateState = function () {
        var viewportTop = scrollTop(this.item);
        var viewportHeight = getViewportHeight(this.item);
        var contentHeight = getContentHeight(this.item);
        var needsRecalcuate = viewportHeight !== this.viewportHeight || contentHeight !== this.contentHeight;
        this.viewportTop = viewportTop;
        this.viewportHeight = viewportHeight;
        this.viewportBottom = viewportTop + viewportHeight;
        this.contentHeight = contentHeight;
        if (needsRecalcuate) {
            var i = this.watchers.length;
            while (i--) {
                this.watchers[i].recalculateLocation();
            }
        }
    };
    ScrollMonitorContainer.prototype.updateAndTriggerWatchers = function (event) {
        var i = this.watchers.length;
        while (i--) {
            this.watchers[i].update();
        }
        i = this.watchers.length;
        while (i--) {
            this.watchers[i].triggerCallbacks(event);
        }
    };
    ScrollMonitorContainer.prototype.createContainer = function (input) {
        var item;
        if (typeof input === 'string') {
            item = document.querySelector(input);
        }
        else if (Array.isArray(input) || input instanceof NodeList) {
            item = input[0];
        }
        else {
            item = input;
        }
        var container = new ScrollMonitorContainer(item, this);
        this.updateState();
        container.listenToDOM();
        return container;
    };
    ScrollMonitorContainer.prototype.create = function (input, offsets) {
        var item;
        if (typeof item === 'string') {
            item = document.querySelector(item);
        }
        else if (Array.isArray(input) || input instanceof NodeList) {
            item = input[0];
        }
        else {
            item = input;
        }
        var watcher = new __WEBPACK_IMPORTED_MODULE_1__watcher_js__["a" /* Watcher */](this, item, offsets);
        this.watchers.push(watcher);
        return watcher;
    };
    /**
     * @deprecated since version 1.1
     */
    ScrollMonitorContainer.prototype.beget = function (input, offsets) {
        return this.create(input, offsets);
    };
    return ScrollMonitorContainer;
}());

//# sourceMappingURL=container.js.map

/***/ }),

/***/ 4:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Watcher; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_js__ = __webpack_require__(2);

var Watcher = /** @class */ (function () {
    function Watcher(container, watchItem, offsets) {
        this.container = container;
        this.watchItem = watchItem;
        this.locked = false;
        this.callbacks = {};
        var self = this;
        if (!offsets) {
            this.offsets = __WEBPACK_IMPORTED_MODULE_0__constants_js__["h" /* defaultOffsets */];
        }
        else if (typeof offsets === 'number') {
            this.offsets = { top: offsets, bottom: offsets };
        }
        else {
            this.offsets = {
                top: 'top' in offsets ? offsets.top : __WEBPACK_IMPORTED_MODULE_0__constants_js__["h" /* defaultOffsets */].top,
                bottom: 'bottom' in offsets ? offsets.bottom : __WEBPACK_IMPORTED_MODULE_0__constants_js__["h" /* defaultOffsets */].bottom,
            };
        }
        for (var i = 0, j = __WEBPACK_IMPORTED_MODULE_0__constants_js__["i" /* eventTypes */].length; i < j; i++) {
            self.callbacks[__WEBPACK_IMPORTED_MODULE_0__constants_js__["i" /* eventTypes */][i]] = [];
        }
        this.locked = false;
        var wasInViewport;
        var wasFullyInViewport;
        var wasAboveViewport;
        var wasBelowViewport;
        var listenerToTriggerListI;
        var listener;
        var needToTriggerStateChange = false;
        function triggerCallbackArray(listeners, event) {
            needToTriggerStateChange = true;
            if (listeners.length === 0) {
                return;
            }
            listenerToTriggerListI = listeners.length;
            while (listenerToTriggerListI--) {
                listener = listeners[listenerToTriggerListI];
                listener.callback.call(self, event, self);
                if (listener.isOne) {
                    listeners.splice(listenerToTriggerListI, 1);
                }
            }
        }
        this.triggerCallbacks = function triggerCallbacks(event) {
            if (this.isInViewport && !wasInViewport) {
                triggerCallbackArray(this.callbacks[__WEBPACK_IMPORTED_MODULE_0__constants_js__["a" /* ENTERVIEWPORT */]], event);
            }
            if (this.isFullyInViewport && !wasFullyInViewport) {
                triggerCallbackArray(this.callbacks[__WEBPACK_IMPORTED_MODULE_0__constants_js__["c" /* FULLYENTERVIEWPORT */]], event);
            }
            if (this.isAboveViewport !== wasAboveViewport &&
                this.isBelowViewport !== wasBelowViewport) {
                triggerCallbackArray(this.callbacks[__WEBPACK_IMPORTED_MODULE_0__constants_js__["g" /* VISIBILITYCHANGE */]], event);
                // if you skip completely past this element
                if (!wasFullyInViewport && !this.isFullyInViewport) {
                    triggerCallbackArray(this.callbacks[__WEBPACK_IMPORTED_MODULE_0__constants_js__["c" /* FULLYENTERVIEWPORT */]], event);
                    triggerCallbackArray(this.callbacks[__WEBPACK_IMPORTED_MODULE_0__constants_js__["e" /* PARTIALLYEXITVIEWPORT */]], event);
                }
                if (!wasInViewport && !this.isInViewport) {
                    triggerCallbackArray(this.callbacks[__WEBPACK_IMPORTED_MODULE_0__constants_js__["a" /* ENTERVIEWPORT */]], event);
                    triggerCallbackArray(this.callbacks[__WEBPACK_IMPORTED_MODULE_0__constants_js__["b" /* EXITVIEWPORT */]], event);
                }
            }
            if (!this.isFullyInViewport && wasFullyInViewport) {
                triggerCallbackArray(this.callbacks[__WEBPACK_IMPORTED_MODULE_0__constants_js__["e" /* PARTIALLYEXITVIEWPORT */]], event);
            }
            if (!this.isInViewport && wasInViewport) {
                triggerCallbackArray(this.callbacks[__WEBPACK_IMPORTED_MODULE_0__constants_js__["b" /* EXITVIEWPORT */]], event);
            }
            if (this.isInViewport !== wasInViewport) {
                triggerCallbackArray(this.callbacks[__WEBPACK_IMPORTED_MODULE_0__constants_js__["g" /* VISIBILITYCHANGE */]], event);
            }
            if (needToTriggerStateChange) {
                needToTriggerStateChange = false;
                triggerCallbackArray(this.callbacks[__WEBPACK_IMPORTED_MODULE_0__constants_js__["f" /* STATECHANGE */]], event);
            }
            wasInViewport = this.isInViewport;
            wasFullyInViewport = this.isFullyInViewport;
            wasAboveViewport = this.isAboveViewport;
            wasBelowViewport = this.isBelowViewport;
        };
        this.recalculateLocation = function () {
            if (this.locked) {
                return;
            }
            var previousTop = this.top;
            var previousBottom = this.bottom;
            if (this.watchItem.nodeName) {
                // a dom element
                var cachedDisplay = this.watchItem.style.display;
                if (cachedDisplay === 'none') {
                    this.watchItem.style.display = '';
                }
                var containerOffset = 0;
                var container = this.container;
                while (container.containerWatcher) {
                    containerOffset +=
                        container.containerWatcher.top -
                            container.containerWatcher.container.viewportTop;
                    container = container.containerWatcher.container;
                }
                var boundingRect = this.watchItem.getBoundingClientRect();
                this.top = boundingRect.top + this.container.viewportTop - containerOffset;
                this.bottom = boundingRect.bottom + this.container.viewportTop - containerOffset;
                if (cachedDisplay === 'none') {
                    this.watchItem.style.display = cachedDisplay;
                }
            }
            else if (this.watchItem === +this.watchItem) {
                // number
                if (this.watchItem > 0) {
                    this.top = this.bottom = this.watchItem;
                }
                else {
                    this.top = this.bottom = this.container.documentHeight - this.watchItem;
                }
            }
            else {
                // an object with a top and bottom property
                this.top = this.watchItem.top;
                this.bottom = this.watchItem.bottom;
            }
            this.top -= this.offsets.top;
            this.bottom += this.offsets.bottom;
            this.height = this.bottom - this.top;
            if ((previousTop !== undefined || previousBottom !== undefined) &&
                (this.top !== previousTop || this.bottom !== previousBottom)) {
                triggerCallbackArray(this.callbacks[__WEBPACK_IMPORTED_MODULE_0__constants_js__["d" /* LOCATIONCHANGE */]], undefined);
            }
        };
        this.recalculateLocation();
        this.update();
        wasInViewport = this.isInViewport;
        wasFullyInViewport = this.isFullyInViewport;
        wasAboveViewport = this.isAboveViewport;
        wasBelowViewport = this.isBelowViewport;
    }
    Watcher.prototype.on = function (event, callback, isOne) {
        if (isOne === void 0) { isOne = false; }
        // trigger the event if it applies to the element right now.
        switch (true) {
            case event === __WEBPACK_IMPORTED_MODULE_0__constants_js__["g" /* VISIBILITYCHANGE */] && !this.isInViewport && this.isAboveViewport:
            case event === __WEBPACK_IMPORTED_MODULE_0__constants_js__["a" /* ENTERVIEWPORT */] && this.isInViewport:
            case event === __WEBPACK_IMPORTED_MODULE_0__constants_js__["c" /* FULLYENTERVIEWPORT */] && this.isFullyInViewport:
            case event === __WEBPACK_IMPORTED_MODULE_0__constants_js__["b" /* EXITVIEWPORT */] && this.isAboveViewport && !this.isInViewport:
            case event === __WEBPACK_IMPORTED_MODULE_0__constants_js__["e" /* PARTIALLYEXITVIEWPORT */] && this.isInViewport && this.isAboveViewport:
                callback.call(this, this);
                if (isOne) {
                    return;
                }
        }
        if (this.callbacks[event]) {
            this.callbacks[event].push({ callback: callback, isOne: isOne });
        }
        else {
            throw new Error('Tried to add a scroll monitor listener of type ' +
                event +
                '. Your options are: ' +
                __WEBPACK_IMPORTED_MODULE_0__constants_js__["i" /* eventTypes */].join(', '));
        }
    };
    Watcher.prototype.off = function (event, callback) {
        if (this.callbacks[event]) {
            for (var i = 0, item; (item = this.callbacks[event][i]); i++) {
                if (item.callback === callback) {
                    this.callbacks[event].splice(i, 1);
                    break;
                }
            }
        }
        else {
            throw new Error('Tried to remove a scroll monitor listener of type ' +
                event +
                '. Your options are: ' +
                __WEBPACK_IMPORTED_MODULE_0__constants_js__["i" /* eventTypes */].join(', '));
        }
    };
    Watcher.prototype.one = function (event, callback) {
        this.on(event, callback, true);
    };
    Watcher.prototype.recalculateSize = function () {
        if (this.watchItem instanceof HTMLElement) {
            this.height = this.watchItem.offsetHeight + this.offsets.top + this.offsets.bottom;
            this.bottom = this.top + this.height;
        }
    };
    Watcher.prototype.update = function () {
        this.isAboveViewport = this.top < this.container.viewportTop;
        this.isBelowViewport = this.bottom > this.container.viewportBottom;
        this.isInViewport =
            this.top < this.container.viewportBottom && this.bottom > this.container.viewportTop;
        this.isFullyInViewport =
            (this.top >= this.container.viewportTop &&
                this.bottom <= this.container.viewportBottom) ||
                (this.isAboveViewport && this.isBelowViewport);
    };
    Watcher.prototype.destroy = function () {
        var index = this.container.watchers.indexOf(this), self = this;
        this.container.watchers.splice(index, 1);
        self.callbacks = {};
    };
    // prevent recalculating the element location
    Watcher.prototype.lock = function () {
        this.locked = true;
    };
    Watcher.prototype.unlock = function () {
        this.locked = false;
    };
    return Watcher;
}());

var eventHandlerFactory = function (type) {
    return function (callback, isOne) {
        if (isOne === void 0) { isOne = false; }
        this.on.call(this, type, callback, isOne);
    };
};
for (var i = 0, j = __WEBPACK_IMPORTED_MODULE_0__constants_js__["i" /* eventTypes */].length; i < j; i++) {
    var type = __WEBPACK_IMPORTED_MODULE_0__constants_js__["i" /* eventTypes */][i];
    Watcher.prototype[type] = eventHandlerFactory(type);
}
//# sourceMappingURL=watcher.js.map

/***/ }),

/***/ 6:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_container_js__ = __webpack_require__(3);
/* unused harmony reexport ScrollMonitorContainer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_watcher_js__ = __webpack_require__(4);
/* unused harmony reexport Watcher */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_types__ = __webpack_require__(8);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_constants_js__ = __webpack_require__(2);





// this is needed for the type, but if we're not in a browser the only
// way listenToDOM will be called is if you call scrollmonitor.createContainer
// and you can't do that until you have a DOM element.
var scrollMonitor = new __WEBPACK_IMPORTED_MODULE_0__src_container_js__["a" /* ScrollMonitorContainer */](__WEBPACK_IMPORTED_MODULE_3__src_constants_js__["j" /* isInBrowser */] ? document.body : undefined);
if (__WEBPACK_IMPORTED_MODULE_3__src_constants_js__["j" /* isInBrowser */]) {
    scrollMonitor.updateState();
    scrollMonitor.listenToDOM();
}
//@ts-ignore
window.scrollMonitor = scrollMonitor;
/* harmony default export */ __webpack_exports__["a"] = (scrollMonitor);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 7:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = numberFormat;
/**
 * JavaScript equivalent of PHPs number_format()
 */
function numberFormat(number, decimals, dec_point, thousands_sep) {

    // Strip all characters but numerical ones.
    number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
    var n = !isFinite(+number) ? 0 : +number,
        prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
        sep = typeof thousands_sep === 'undefined' ? ',' : thousands_sep,
        dec = typeof dec_point === 'undefined' ? '.' : dec_point,
        s = '',
        toFixedFix = function toFixedFix(n, prec) {
        var k = Math.pow(10, prec);
        return '' + Math.round(n * k) / k;
    };
    // Fix for IE parseFloat(0.55).toFixed(0) = 0;
    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
    if (s[0].length > 3) {
        s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || '').length < prec) {
        s[1] = s[1] || '';
        s[1] += new Array(prec - s[1].length + 1).join('0');
    }
    return s.join(dec);
}

/***/ }),

/***/ 8:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

//# sourceMappingURL=types.js.map

/***/ })

},[125]);


// WEBPACK FOOTER //
// personalizer.7f811ddc4236c2019140.js